<template>
  <div>
    <div id="info-bar" v-if="selectedToEdit > 0">
      {{ items.filter(i => i.id === selectedToEdit)[0].sku }} kann ersetzt werden mit {{ stringShow }} <button @click="saveReplacement">Speichern (nur dieses)</button> <input type="password" v-model="auth">
    </div>
    <div class="row-wrapper">
      <div v-for="(i, idx) in items" :key="idx" class="row">
        <div class="col1">
          <input type="radio" name="toAdd" :value="i.id" @change="selectedToEdit = i.id; stringShow = getHumanReadableString()">
        </div>
        <div class="col2">
          {{ i.name }} ({{ i.sku }})
        </div>
        <div class="col3">
          <input v-if="selectedToEdit > 0" type="number" :value="selectedProduct.replaceProducts[i.id]" @change="v => updateKeys(v.target.value, i.id)">
        </div>
        <div class="col4">
          {{ i.stock_status }}, {{ i.stock_quantity }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  mixins: [logicMixin],
  data () {
    return {
      hasLoaded: false,
      items: [],
      importance: {},
      selectedToEdit: 0,
      stringShow: '',
      auth: ''
    };
  },
  mounted: function () {
    axios.get(
      process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_level_3_fast'
    ).then(response => {
      this.items = this.extendLvl3Req(response.data);
    });
  },
  methods: {
    getHumanReadableString() {
      var ret = [];
      Object.keys(this.selectedProduct.replaceProducts).forEach(key => {
        ret.push([
          this.items.filter(i => i.id === parseInt(key))[0].sku,
          parseInt(this.selectedProduct.replaceProducts[key])
        ]);
      });

      ret = ret.sort((a, b) => a[1] - b[1]).map(i => i.join(': '));

      return ret.join(', ');
    },
    updateKeys(val, id) {
      if (val === '') {
        delete this.selectedProduct.replaceProducts[id];
      } else {
        this.selectedProduct.replaceProducts[id] = parseInt(val);
      }
      this.stringShow = this.getHumanReadableString();
    },
    saveReplacement() {
      axios.post(
        process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/save_replacements',
        {
          productId: parseInt(this.selectedToEdit),
          replacements: JSON.stringify(this.selectedProduct.replaceProducts),
          auth: this.auth
        }
      ).then(response => {
        if (response.data.status !== 'success') {
          alert('Kein Passwort');
        }
      }).catch(() => {
        alert('Fehler beim speichern');
      });
    }
  },
  computed: {
    selectedProduct() {
      if (this.selectedToEdit === 0) return undefined;
      return this.items.filter(i => i.id === this.selectedToEdit)[0];
    }
  },
  metaInfo () {
    return {
      title: 'Admin - Produktersetzung'
    };
  }
};
</script>

<style lang="scss" scoped>
#info-bar {
  position: fixed;
  top: 5px;
  left: 5px;
  background: white;
  box-shadow: 0 0 4px #aeaeae;
  padding: 4px;
}
.row-wrapper {
  margin-top: 50px;
}
.row {
  width: 90%;
  padding: 3px 0;
  border-bottom: 1px solid #aeaeae;
  margin-left: 5%;
}
.col1, .col2, .col3, .col4 {
  display: inline;
}
.col1 {
  width: 100px;
}
.col2 {
  width: 40%;
}
.col3 {
  width: 30%;
}
.col4 {
  width: calc(30% - 100px);
}
</style>
